var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook 1",
    clipPath: "url(#clip0_3060_2561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 12.5C23.9991 10.2059 23.3412 7.95998 22.1041 6.02826C20.8671 4.09654 19.1026 2.55988 17.0197 1.60021C14.9368 0.640539 12.6226 0.298039 10.3512 0.613258C8.07976 0.928478 5.94616 1.88822 4.203 3.37885C2.45984 4.86949 1.18011 6.8286 0.515314 9.02425C-0.149479 11.2199 -0.171497 13.5602 0.451868 15.7679C1.07523 17.9757 2.31787 19.9586 4.03268 21.4818C5.74749 23.005 7.86265 24.0047 10.1278 24.3627V15.9679H7.07518V12.5H10.1278V9.85334C10.1278 6.84696 11.9186 5.1843 14.6591 5.1843C15.5682 5.19598 16.4752 5.27538 17.3725 5.42182V8.3739H15.8327C15.5747 8.33935 15.3123 8.36325 15.0648 8.44384C14.8173 8.52442 14.5911 8.65962 14.4029 8.83945C14.2146 9.01929 14.0692 9.23914 13.9774 9.48277C13.8855 9.72639 13.8496 9.98756 13.8722 10.2469V12.5H17.2029L16.6738 15.9679H13.8722V24.3627C16.6955 23.9151 19.2666 22.4746 21.1231 20.3001C22.9796 18.1256 23.9997 15.3598 24 12.5Z",
    fill: "#337FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6746 15.9679L17.2037 12.5H13.873V10.2469C13.8504 9.98753 13.8863 9.72636 13.9782 9.48274C14.07 9.23911 14.2154 9.01926 14.4036 8.83942C14.5919 8.65959 14.8181 8.52439 15.0656 8.4438C15.3131 8.36322 15.5755 8.33932 15.8335 8.37387H17.3462V5.42179C16.4489 5.27535 15.5419 5.19595 14.6328 5.18427C11.9194 5.18427 10.1014 6.84693 10.1014 9.85331V12.5H7.04883V15.9679H10.1014V24.3626C11.3423 24.5527 12.605 24.5527 13.8459 24.3626V15.9679H16.6746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3060_2561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.0103,
    fill: "white",
    transform: "translate(0 0.494873)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.cd97192a29c7714fab64691bc2b6488c.svg";
export { ForwardRef as ReactComponent };